import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";
import Layers from "slotworks/graphics/layers/layers";

export function FadeSymbolsCommand(symbols: SymbolComponent[], type: string): Contract<void> {
    const dimSymbolMethods: Array<() => Contract<void>> = [];

    for (const symbol of symbols) {
        if(symbol.symbolId != type) {
            dimSymbolMethods.push(() => symbol.dim());
            symbol.setSymbolFade(false);
        }
    }

    return parallel(dimSymbolMethods);
}

export function RestoreSymbolsCommand(symbols: SymbolComponent[]) {
    for (const symbol of symbols) {
        symbol.setSymbolFade(true);
    }
}

export function UnlockSymbols(symbols: SymbolComponent[]) {
    for(const symbol of symbols) {
        symbol.unlockLayer();
        if(symbol.getLayer() != Layers.MatrixContent) {
            symbol.setLayer(Layers.MatrixContent);
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/symbols-commands.ts